import type { MerchantRoutes } from "@redotech/redo-merchant-app-common/merchant-routes";
import {
  getSettingCatalogGroup,
  type SettingGroupFullPageTarget,
} from "@redotech/redo-model/settings-catalog/index";
import { assertNever } from "@redotech/util/type";

type SettingsGroupFullPageRoutes = Pick<
  MerchantRoutes,
  "getSettingsSubRoute" | "legacySupportBaseUrl" | "settingsHref"
>;

export function getSettingsGroupFullPageHref({
  groupId,
  routes,
}: {
  groupId: string;
  routes: SettingsGroupFullPageRoutes;
}): string {
  return resolveSettingsGroupFullPageHref({
    fullPageTarget: getSettingCatalogGroup(groupId)?.fullPageTarget,
    routes,
  });
}

function resolveSettingsGroupFullPageHref({
  fullPageTarget,
  routes,
}: {
  fullPageTarget: SettingGroupFullPageTarget | undefined;
  routes: SettingsGroupFullPageRoutes;
}): string {
  if (!fullPageTarget) {
    return routes.settingsHref;
  }

  switch (fullPageTarget.type) {
    case "settings":
      return routes.getSettingsSubRoute(fullPageTarget.path);
    case "legacySupport":
      return `${routes.legacySupportBaseUrl}${fullPageTarget.path}`;
    case "settingsHome":
      return routes.settingsHref;
    default:
      assertNever(fullPageTarget);
  }
}
